import OSS from 'ali-oss';
import { Message, Loading, MessageBox } from 'element-ui';
import dayjs from 'dayjs';
import { ApplicationContext } from '@/utils/context';
import html2canvas from "html2canvas";

const client = new OSS({
    region: 'oss-cn-shanghai', // 你要上传到的OSS区域，替换为你的区域
    accessKeyId: "LTAI5tMQSZKCnPQgC7X27xM5",
    accessKeySecret: "uHR98INc84MIrPwCXvgQN6vnA4VjGd",
    bucket: 'netollie-image-scene-recognition', // 替换为你的OSS bucket名
    connectTimeout: 300000, // 连接超时设置为30秒
    timeout: 300000, // 读取超时设置为30秒
});

const generateThumbnail = async(file) => {
    const imageTypes = [
        'image/jpeg',    // JPEG 格式
        'image/png',     // PNG 格式
        'image/gif',     // GIF 格式
        'image/bmp',     // BMP 格式
        'image/webp',    // WebP 格式
        'image/svg+xml', // SVG 格式
        'image/tiff',    // TIFF 格式
        'image/x-icon',  // ICO 格式
        'image/heif',    // HEIF 格式
        'image/jp2',     // JPEG 2000 格式
        'image/avif'     // AVIF 格式
    ];
    if (imageTypes.includes(file.type.toLowerCase())) {
        let canvas = document.createElement('canvas');
        const context = canvas.getContext('2d');
        return new Promise((resolve, reject) => {
            const reader = new FileReader();
            reader.onload = function(event) {
                const image = new Image();
                image.onload = function() {
                    let fixed = 350;
                    let width, height;
                    if (image.width < fixed && image.height < fixed) {
                        width = image.width;
                        height = image.height;
                    } else if (image.width > image.height) {
                        width = fixed;
                        height = (image.height / image.width) * fixed;
                    } else {
                        height = fixed;
                        width = (image.width / image.height) * fixed;
                    }
                    canvas.width = width;
                    canvas.height = height;
                    context.clearRect(0, 0, canvas.width, canvas.height);
                    context.drawImage(image, 0, 0, canvas.width, canvas.height);
                    canvas.toBlob(function(blob) {
                        if (blob) {
                            resolve(blob);  // 成功生成 blob，返回给调用者
                        } else {
                            reject(new Error('Failed to generate blob'));  // 处理生成 blob 失败的情况
                        }
                    }, 'image/png');  // 设置上传格式为 PNG
                };
                image.src = event.target.result;
            };
            reader.onerror = function(error) {
                reject(error);
            };
            reader.readAsDataURL(file);
        });
    }
    const rarTypes = [
        'application/zip',                  // ZIP 文件
        'application/x-rar-compressed',     // RAR 文件
        'application/x-7z-compressed',      // 7z 文件
        'application/gzip',                 // Gzip 文件
        'application/x-tar',                // TAR 文件
        'application/x-bzip2',              // Bzip2 文件
        'application/x-xz',                 // XZ 文件
        'application/x-lzma',               // LZMA 文件
        'application/x-gtar',               // GNU Tar 文件（通常是 tar 格式的一种）
        'application/x-compressed',         // 另一种通用压缩格式（有时用于 `.tar.Z` 文件）
        'application/x-zip-compressed'      // 类似 ZIP，但有时会用于特殊类型的压缩文件
    ];
    if (rarTypes.includes(file.type.toLowerCase())) {
        const imageUrl = require('@/assets/file_rar.png');  // 获取打包后的图片 URL
        const response = await fetch(imageUrl);
        return await response.blob();  // 转为 Blob 对象
    }
    const txtTypes = ['text/plain'];
    if (txtTypes.includes(file.type.toLowerCase())) {
        const imageUrl = require('@/assets/file_txt.png');  // 获取打包后的图片 URL
        const response = await fetch(imageUrl);
        return await response.blob();  // 转为 Blob 对象
    }
    const wordTypes = [
        'application/msword',
        'application/vnd.openxmlformats-officedocument.wordprocessingml.document'
    ];
    if (wordTypes.includes(file.type.toLowerCase())) {
        return new Promise((resolve, reject) => {
            ApplicationContext.$off('finish_rendering_docx');
            ApplicationContext.$on('finish_rendering_docx', async event => {
                ApplicationContext.$off('finish_rendering_docx');
                if (event.success) {
                    const element = event.canvas;
                    const canvas = document.createElement("canvas");
                    const context = canvas.getContext("2d");
                    let fixed = 350;
                    let width, height;
                    if (element.width < fixed && element.height < fixed) {
                        width = element.width;
                        height = element.height;
                    } else if (element.width > element.height) {
                        width = fixed;
                        height = (element.height / element.width) * fixed;
                    } else {
                        height = fixed;
                        width = (element.width / element.height) * fixed;
                    }
                    canvas.width = width;
                    canvas.height = height;
                    context.clearRect(0, 0, width, height);
                    context.drawImage(element, 0, 0, width, height);
                    canvas.toBlob(function(blob) {
                        if (blob) {
                            resolve(blob);  // 成功生成 blob，返回给调用者
                        } else {
                            reject(new Error('Failed to generate blob'));  // 处理生成 blob 失败的情况
                        }
                    }, 'image/png');  // 设置上传格式为 PNG
                } else {
                    let imageUrl = require('@/assets/file_ppt.png');  // 获取打包后的图片 URL
                    let response = await fetch(imageUrl);
                    resolve(await response.blob());  // 转为 Blob 对象
                }
            });
            let fileReader = new FileReader();
            fileReader.onload =  () => {
                ApplicationContext.$emit('do_rendering_docx', fileReader.result);        
            }
            fileReader.readAsArrayBuffer(file);  
        });
    }
    const excelTypes = [
        'application/vnd.ms-excel',                              // .xls
        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet', // .xlsx
        'application/vnd.oasis.opendocument.spreadsheet',        // .ods
        'text/csv',                                              // .csv (逗号分隔值)
        'application/vnd.ms-excel.sheet.binary.macroEnabled.12',  // .xlsb
        'application/vnd.ms-excel.sheet.macroEnabled.12',        // .xlsm (宏启用 Excel 文件)
        'application/vnd.google-apps.spreadsheet'                // Google Sheets
    ];
    if (excelTypes.includes(file.type.toLowerCase())) {
        const imageUrl = require('@/assets/file_excel.png');  // 获取打包后的图片 URL
        const response = await fetch(imageUrl);
        return await response.blob();  // 转为 Blob 对象
    }
    const musicTypes = [
        'audio/mpeg',     // MP3 文件
        'audio/wav',      // WAV 文件
        'audio/ogg',      // OGG 文件
        'audio/aac',      // AAC 文件
        'audio/flac',     // FLAC 文件
        'audio/midi',     // MIDI 文件
        'audio/x-midi',   // MIDI 文件（备用）
        'audio/webm',     // WebM 音频文件
        'audio/alac',     // ALAC 文件 (Apple Lossless Audio Codec)
        'audio/mp4'       // M4A 文件 (AAC 编码音频文件)
    ];
    if (musicTypes.includes(file.type.toLowerCase())) {
        const imageUrl = require('@/assets/file_music.png');  // 获取打包后的图片 URL
        const response = await fetch(imageUrl);
        return await response.blob();  // 转为 Blob 对象
    }
    const videoTypes = [
        'video/mp4',           // MP4 文件
        'video/webm',          // WEBM 文件
        'video/x-msvideo',     // AVI 文件
        'video/x-matroska',    // MKV 文件
        'video/x-flv',         // FLV 文件
        'video/ogg',           // OGG 视频文件
        'video/hevc'          // HEVC/H.265 视频文件
    ];
    if (videoTypes.includes(file.type.toLowerCase())) {
        return new Promise((resolve, reject) => {
            let video = document.createElement('video');
            let canvas = document.createElement('canvas');
            let context = canvas.getContext('2d');
            video.src = URL.createObjectURL(file);
            video.preload = 'metadata';
            video.onloadedmetadata = () => {
                let fixed = 350;
                if (video.videoWidth < fixed && video.videoHeight < fixed) {
                    canvas.width = video.videoWidth;
                    canvas.height = video.videoHeight;
                } else if (video.videoWidth > video.videoHeight) {
                    canvas.width = fixed;
                    canvas.height = (video.videoHeight / video.videoWidth) * fixed;
                } else {
                    canvas.height = fixed;
                    canvas.width = (video.videoWidth / video.videoHeight) * fixed;
                }
                video.currentTime = 1;
                video.onseeked = () => {
                    context.drawImage(video, 0, 0, canvas.width, canvas.height);
                    canvas.toBlob(function(blob) {
                        if (blob) {
                            resolve(blob);
                        } else {
                            reject(new Error('Failed to generate blob'));  // 处理生成 blob 失败的情况
                        }
                    }, 'image/png'); 
                    URL.revokeObjectURL(video.src);
                };
            };
        });
    }
    if (['video/quicktime','video/prores', 'video/x-m4v'].includes(file.type)) {
        const imageUrl = require('@/assets/file_video.png');  
        const response = await fetch(imageUrl);
        return await response.blob();
    }
    const pptxTypes = [
        'application/vnd.openxmlformats-officedocument.presentationml.presentation', // .pptx 文件
        'application/vnd.openxmlformats-officedocument.presentationml.slideshow',    // .ppsx 文件
        'application/vnd.ms-powerpoint.presentation.macroenabled.12',                // 带宏的 .ppt 文件
        'application/vnd.ms-powerpoint.slideshow.macroenabled.12'                    // 带宏的 .pps 文件
    ];
    if (pptxTypes.includes(file.type.toLowerCase())) {
        return new Promise((resolve, reject) => {
            ApplicationContext.$off('finish_rendering_pptx');
            ApplicationContext.$on('finish_rendering_pptx', async event => {
                ApplicationContext.$off('finish_rendering_pptx');
                if (event.success) {
                    const element = await html2canvas(event.elements[0]);
                    const canvas = document.createElement("canvas");
                    canvas.width = 350;
                    canvas.height = element.height * 350 / element.width;
                    const context = canvas.getContext("2d");
                    context.clearRect(0, 0, canvas.width, canvas.height);
                    context.drawImage(element, 0, 0, canvas.width, canvas.height);
                    canvas.toBlob(function(blob) {
                        if (blob) {
                            resolve(blob);  // 成功生成 blob，返回给调用者
                        } else {
                            reject(new Error('Failed to generate blob'));  // 处理生成 blob 失败的情况
                        }
                    }, 'image/png');  // 设置上传格式为 PNG
                } else {
                    let imageUrl = require('@/assets/file_ppt.png');  // 获取打包后的图片 URL
                    let response = await fetch(imageUrl);
                    resolve(await response.blob());  // 转为 Blob 对象
                }
            });
            let fileReader = new FileReader();
            fileReader.onload =  () => {
                ApplicationContext.$emit('do_rendering_pptx', fileReader.result);        
            }
            fileReader.readAsArrayBuffer(file);  
        });
    }
    const pptTypes = [
        'application/vnd.oasis.opendocument.presentation'              // .odp 文件
    ];
    if (pptTypes.includes(file.type.toLowerCase()) || file.type.toLowerCase().startsWith('application/vnd.ms-powerpoint')) {
        const imageUrl = require('@/assets/file_ppt.png');  // 获取打包后的图片 URL
        const response = await fetch(imageUrl);
        return await response.blob();  // 转为 Blob 对象
    }
    const pdfTypes = [
        'application/pdf',
        'application/x-pdf',
        'application/acrobat',
        'application/vnd.adobe.pdf'
    ];
    if (pdfTypes.includes(file.type.toLowerCase())) {
        return new Promise((resolve, reject) => {
            ApplicationContext.$off('finish_rendering_pdf');
            ApplicationContext.$on('finish_rendering_pdf', async event => {
                ApplicationContext.$off('finish_rendering_pdf');
                let page = event.pages[0];
                const canvas = document.createElement("canvas");
                canvas.width = 350;
                canvas.height = page.height * 350 / page.width;
                const context = canvas.getContext("2d");
                context.clearRect(0, 0, canvas.width, canvas.height);
                context.drawImage(page, 0, 0, canvas.width, canvas.height);
                canvas.toBlob(function(blob) {
                    if (blob) {
                        resolve(blob);  // 成功生成 blob，返回给调用者
                    } else {
                        reject(new Error('Failed to generate blob'));  // 处理生成 blob 失败的情况
                    }
                }, 'image/png');  // 设置上传格式为 PNG
            });
            let fileReader = new FileReader();
            fileReader.onload =  () => {
                ApplicationContext.$emit('do_rendering_pdf', fileReader.result);        
            }
            fileReader.readAsArrayBuffer(file);  
        });
    }
    const imageUrl = require('@/assets/file_unknown.png');  // 获取打包后的图片 URL
    const response = await fetch(imageUrl);
    return await response.blob();  // 转为 Blob 对象
}

export default {
    async listObject() {
        try {
            let objects = [];
            let marker = null;
            do {
                let onePage = await client.list({
                    prefix: 'netollie-cloud-disk/demo/',  // 指定目录路径或前缀
                    delimiter: '/',  // 使用 '/' 分隔模拟文件夹
                    'max-keys': 100,    // 每次列出最多100个对象（可以根据需要调整）
                    marker: marker
                });
                marker = onePage.nextMarker;
                let now = dayjs();
                onePage.objects.forEach(object => {
                    if (!object.name.endsWith('.thumbnail') && object.name !== 'netollie-cloud-disk/demo/') {
                        // 处理文件修改日期
                        let lastModified = dayjs(object.lastModified);
                        let diffDays = now.startOf('day').diff(lastModified.startOf('day'), 'day');
                        if (diffDays >= 2) {
                          object.fileSimplifiedModifiedTime = lastModified.format('MM/DD HH:mm');
                        } else if (diffDays === 1) {
                          object.fileSimplifiedModifiedTime = `昨天 ${lastModified.format('HH:mm')}`;
                        } else if (diffDays === 0) {
                          object.fileSimplifiedModifiedTime = `今天 ${lastModified.format('HH:mm')}`;
                        } else {
                          object.fileSimplifiedModifiedTime = lastModified.format('MM/DD HH:mm');
                        }
                        // 处理文件大小
                        let sizeText = '';
                        if (object.size === 0) {
                            sizeText = '0 B';
                        } else {
                            let sizeUnits = ['B', 'KB', 'MB', 'GB', 'TB', 'PB', 'EB'];
                            const i = Math.floor(Math.log(object.size) / Math.log(1024));  // 计算文件大小应该用哪个单位
                            sizeText = parseFloat((object.size / Math.pow(1024, i)).toFixed(2)) + ' ' + sizeUnits[i];
                        }
                        object.size = sizeText;
                        // 带上缩略图
                        object.picture = `https://netollie-image-scene-recognition.oss-cn-shanghai.aliyuncs.com/${encodeURIComponent(object.name)}.thumbnail`;
                        // 处理文件名
                        object.name = object.name.replace(/^netollie-cloud-disk\/demo\//, '');
                        // 分析文件类型
                        let extension = object.name.split('.').pop().toLowerCase();
                        switch (extension) {
                          case 'jpg':
                          case 'jpeg':
                          case 'png':
                          case 'gif':
                          case 'bmp':
                          case 'tiff':
                          case 'webp':
                            object.type =  'image';
                            break;
                      
                          case 'mp4':
                          case 'avi':
                          case 'mov':
                          case 'mkv':
                          case 'flv':
                          case 'wmv':
                          case 'rmvb':
                            object.type = 'video';
                            break;
                      
                          case 'pdf':
                            object.type = 'pdf';
                            break;
                      
                          case 'doc':
                          case 'docx':
                            object.type = 'word';
                            break;
                      
                          case 'ppt':
                          case 'pptx':
                            object.type = 'ppt';
                            break;
                      
                          case 'xls':
                          case 'xlsx':
                            object.type = 'excel';
                            break;
                      
                          case 'mp3':
                          case 'wav':
                          case 'ogg':
                          case 'flac':
                            object.type = 'music';
                            break;
                      
                          default:
                            object.type = 'unknown';
                            break;
                        }
                        objects.push(object);
                    }
                });
            } while (null !== marker);
            objects.sort((a, b) => {
                const dateA = new Date(a.lastModified);
                const dateB = new Date(b.lastModified);
                return dateB - dateA;
              });              
            return objects;
        } catch (error) {
            Message({message: '文件加载失败: ' + error.name, type: 'error'});
            return [];
        }
    },
    async pickAndPutObject(onSuccess) {
        ApplicationContext.$emit('do_picking_file');
        ApplicationContext.$off('finish_picking_file');
        ApplicationContext.$on('finish_picking_file', async files => {
            this.putObject(files, onSuccess);
        });
    },
    async putObject(files, onSuccess) {
        let loading = Loading.service({ text: '准备上传', lock: true, spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
        let success = 0;
        for (let i = 0; i < files.length; i++){
            let file = files[i];
            loading.setText('正在生成预览图: ' + (i + 1) + ' / ' + files.length);
            let thumbnail = await generateThumbnail(file);
            try {
                loading.setText('正在上传: ' + (i + 1) + ' / ' + files.length);
                await client.put(`netollie-cloud-disk/demo/${file.name}.thumbnail`, thumbnail);
                await client.put(`netollie-cloud-disk/demo/${file.name}`, file);
                success++;
            } catch (error) {
                Message({message: '文件上传失败: ' + error.name, type: 'error'});
                console.log(error);
            }
        }
        if (success && onSuccess) {
            onSuccess();
        }
        loading.close();
    },
    async downloadObject(file) {
        let url = `https://netollie-image-scene-recognition.oss-cn-shanghai.aliyuncs.com/netollie-cloud-disk/demo/${encodeURIComponent(file.name)}`;
        let link = document.createElement('a');
        link.href = url;
        link.download = file.name;
        link.click();
    },
    async renameObject(file, onSuccess, onCancel) {
        let objects = await this.listObject();
        MessageBox.prompt('', '重命名', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            inputValue: file.name,
            inputPattern: /^[^\\/:*?"<>|]*$/,
            inputErrorMessage: "文件名不能包含下列任何字符\n\\/:*?\"<>|",
            inputValidator: (value) => {
                value = value.trim();
                for (let i = 0; i < objects.length; i++) {
                    let object = objects[i];
                    if (file.name !== value && object.name ===  value) {
                        return `"${value}"已存在`
                    }
                }
                return true;
            }
        }).then(async ({ value }) => {
            value = value.trim();
            if (value !== file.name) {
                let loading = Loading.service({ lock: true, spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
                await client.copy(`netollie-cloud-disk/demo/${value}.thumbnail`, `netollie-cloud-disk/demo/${file.name}.thumbnail`);
                await client.copy(`netollie-cloud-disk/demo/${value}`, `netollie-cloud-disk/demo/${file.name}`);
                await client.delete(`netollie-cloud-disk/demo/${file.name}.thumbnail`);
                await client.delete(`netollie-cloud-disk/demo/${file.name}`);    
                onSuccess && onSuccess();
                loading.close();
            } else {
                onSuccess && onSuccess();

            }
        }).catch(() => {
            onCancel && onCancel();    
        });
    },
    async removeObject(file, onSuccess, onCancel) {
        MessageBox.confirm(`此操作将永久删除"${file.name}", 是否继续?`, '提示', {
          confirmButtonText: '确定',
          cancelButtonText: '取消',
          type: 'warning'
        }).then(async () => {
            let loading = Loading.service({ lock: true, spinner: 'el-icon-loading', background: 'rgba(0, 0, 0, 0.7)' });
            await client.delete(`netollie-cloud-disk/demo/${file.name}.thumbnail`);
            await client.delete(`netollie-cloud-disk/demo/${file.name}`);
            onSuccess && onSuccess();
            loading.close();
        }).catch(() => {
            onCancel && onCancel();
        });
    }
}
